import { useContext } from 'react';
import { AuthContext } from '../App';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import PremiumCard from '../components/support/PremiumCard';
import DonationCard from '../components/support/DonationCard';

const SupportPage = () => {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <div className="min-h-screen bg-[#0A0A0A] py-12 px-4" data-testid="support-page">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-light tracking-tighter mb-4" style={{ fontFamily: 'Outfit' }}>
            <span className="text-[#8B5CF6]">Support</span> the Mission
          </h1>
          <p className="text-lg text-[#A1A1AA] max-w-2xl mx-auto">Help us continue providing mental health support to those who need it</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <PremiumCard isAuthenticated={isAuthenticated} />
          <DonationCard />
        </div>
        <Card className="card-surface border-[#27272A]" data-testid="contact-card">
          <CardHeader>
            <CardTitle style={{ fontFamily: 'Outfit' }}>Need Help?</CardTitle>
            <CardDescription>Get in touch with us</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-[#A1A1AA] mb-4">For support, feedback, or any questions, please contact us at:</p>
            <a href="mailto:Mhvk2793@gmail.com" className="text-[#8B5CF6] hover:text-[#9D6FFF] font-semibold" data-testid="contact-email">Mhvk2793@gmail.com</a>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SupportPage;
